export default {
    /* GET_PRODUCT_TEMPLATES
    ---------------------------------------------------------------
    */
    GET_PRODUCT_TEMPLATES_REQUEST: state => {
        state.productTemplatesLoading = true
    },
    GET_PRODUCT_TEMPLATES_SUCCESS: (state, data) => {
        state.productTemplates = data.results
        state.productTemplatesLoading = false
    },
    GET_PRODUCT_TEMPLATES_FAILURE: state => {
        state.productTemplatesLoading = false
    },
    /* DELETE_PRODUCT_TEMPLATE
    ---------------------------------------------------------------
    */
    DELETE_PRODUCT_TEMPLATE_SUCCESS: (state, productTemplateId) => {
        state.productTemplates = state.productTemplates.filter(productTemplate => productTemplate.id != productTemplateId)
    },

    SET_PRODUCT_TEMPLATES_FILTERS: (state, filters) => {
        state.filters = filters
    },
    CLEAR_PRODUCT_TEMPLATES_FILTERS: state => {
        state.filters = state.setInitialFilters()
    }
}